// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__JIwsG","image":"Header_image__18u9g","name":"Header_name__18p0P","info":"Header_info__2miX1","infoRow":"Header_infoRow__3sQ5A"};